import React from "react";
import heroArtwork from "./assets/league-section-1.png";
import "./LeagueHero.css";

/**
 * Approved League landing page Section 1.
 * The generated concept is used as the visual source of truth while the
 * transparent interaction layer keeps the primary navigation and CTAs live.
 */
export default function LeagueHero() {
  return (
    <section className="league-concept-hero" id="overview" aria-label="MatrixOS League overview">
      <img
        className="league-concept-hero__artwork"
        src={heroArtwork}
        alt="MatrixOS League operational competition platform with live standings and upcoming competition"
      />

      <nav className="league-concept-hero__hotspots" aria-label="League landing navigation">
        <a className="hotspot hotspot--brand" href="/matrixos-enter" aria-label="Back to MatrixOS" />
        <a className="hotspot hotspot--overview" href="#overview" aria-label="Overview" />
        <a className="hotspot hotspot--standings" href="#standings" aria-label="Standings" />
        <a className="hotspot hotspot--events" href="#features" aria-label="Events" />
        <a className="hotspot hotspot--hall" href="#hall" aria-label="Hall of Fame" />
        <a className="hotspot hotspot--pricing" href="/pricing" aria-label="Pricing" />
        <a className="hotspot hotspot--resources" href="/faq" aria-label="Resources" />
        <a className="hotspot hotspot--top-cta" href="/login?app=league" aria-label="Explore League" />
        <a className="hotspot hotspot--primary-cta" href="/login?app=league" aria-label="Explore League" />
        <a className="hotspot hotspot--video" href="#how" aria-label="Watch video" />
        <a className="hotspot hotspot--table" href="#standings" aria-label="View full standings table" />
      </nav>
    </section>
  );
}
